import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard, CheckCircle2, Zap, Star } from 'lucide-react';
export function Hero() {
  const miniTestimonials = [{
    name: 'Andrés G.',
    location: 'Argentina',
    text: 'Empecé a entregar tableros profesionales y pude subir mis precios un 40%.'
  }, {
    name: 'Luis P.',
    location: 'México',
    text: 'Pensé que el PLC era imposible. Ya estoy haciendo mantenimiento industrial.'
  }];
  return <section className="bg-brand-bg text-brand-text pb-8 relative overflow-hidden" data-id="element-112">
      {/* Announcement Bar — single line */}
      <div className="w-full bg-brand-danger text-white text-center py-1.5 px-4 font-bold text-xs md:text-sm flex items-center justify-center gap-2 shadow-md relative z-20 whitespace-nowrap overflow-hidden" data-id="element-113">
        <Zap className="w-3.5 h-3.5 animate-pulse shrink-0" data-id="element-114" />
        <span className="truncate" data-id="element-115">
          OFERTA DE LANZAMIENTO: 80% DE DESCUENTO — SOLO POR HOY
        </span>
        <Zap className="w-3.5 h-3.5 animate-pulse shrink-0" data-id="element-116" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center px-4 pt-6" data-id="element-117">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-poppins font-black mb-3 leading-tight text-brand-text" data-id="element-118">
          Deja de ser un "ayudante" y conviértete en el{' '}
          <span className="text-brand-primary underline decoration-brand-secondary decoration-4 underline-offset-4" data-id="element-119">
            Especialista Eléctrico
          </span>{' '}
          que las industrias buscan y pagan bien.
        </h1>

        <h2 className="text-sm md:text-base font-semibold mb-5 max-w-2xl mx-auto text-brand-steel" data-id="element-120">
          Domina desde instalaciones domiciliarias hasta PLC y Comandos. El
          sistema práctico 4-en-1 para técnicos que quieren dejar de pelear por
          precios bajos.
        </h2>

        <div className="w-full max-w-md md:max-w-xl mx-auto mb-5 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 relative" onClick={scrollToCompra} data-id="element-121">
          <img src="https://cdn.magicpatterns.com/uploads/6Bk7nS1nXvdNoDEXCWnyHC/master_electrotecnico_.png" alt="Master Electrotécnico Sistema Completo" className="w-full h-auto drop-shadow-2xl" data-id="element-122" />
        </div>

        {/* Bullets — single row, compact */}
        <div className="flex flex-row items-center justify-center gap-1.5 md:gap-3 mb-5 w-full max-w-2xl mx-auto flex-wrap" data-id="element-123">
          <div className="flex items-center justify-center bg-white px-2.5 py-1.5 rounded-md border border-brand-section shadow-sm text-[11px] md:text-xs font-bold text-brand-text" data-id="element-124">
            <CheckCircle2 className="w-3.5 h-3.5 mr-1 text-brand-primary shrink-0" data-id="element-125" />
            <span data-id="element-126">Acceso inmediato</span>
          </div>
          <div className="flex items-center justify-center bg-white px-2.5 py-1.5 rounded-md border border-brand-section shadow-sm text-[11px] md:text-xs font-bold text-brand-text" data-id="element-127">
            <CheckCircle2 className="w-3.5 h-3.5 mr-1 text-brand-primary shrink-0" data-id="element-128" />
            <span data-id="element-129">Garantía 14 días</span>
          </div>
          <div className="flex items-center justify-center bg-white px-2.5 py-1.5 rounded-md border border-brand-section shadow-sm text-[11px] md:text-xs font-bold text-brand-text" data-id="element-130">
            <CheckCircle2 className="w-3.5 h-3.5 mr-1 text-brand-primary shrink-0" data-id="element-131" />
            <span data-id="element-132">Moneda local</span>
          </div>
        </div>

        <div className="w-full max-w-lg mx-auto mb-4" data-id="element-133">
          <Button className="w-full text-base md:text-lg py-3 md:py-4" data-id="element-134">
            QUIERO ACCEDER AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-4 text-[11px] md:text-xs text-brand-steel font-semibold mb-6" data-id="element-135">
          <div className="flex items-center" data-id="element-136">
            <ShieldCheck className="w-4 h-4 mr-1 text-brand-primary" data-id="element-137" />
            <span data-id="element-138">Garantía 14 días</span>
          </div>
          <div className="flex items-center" data-id="element-139">
            <Lock className="w-4 h-4 mr-1 text-brand-primary" data-id="element-140" />
            <span data-id="element-141">Pago seguro</span>
          </div>
          <div className="flex items-center" data-id="element-142">
            <CreditCard className="w-4 h-4 mr-1 text-brand-primary" data-id="element-143" />
            <span data-id="element-144">Tarjetas / Efectivo</span>
          </div>
        </div>

        {/* 2 mini testimonials below CTA */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-3xl mx-auto mb-6 w-full" data-id="element-145">
          {miniTestimonials.map((t, i) => <div key={i} className="bg-white border-l-4 border-brand-primary p-3 rounded-r-lg shadow-sm text-left" data-id="element-146">
              <div className="flex text-brand-secondary mb-1" data-id="element-147">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-3 h-3 fill-current" data-id="element-148" />)}
              </div>
              <p className="text-xs md:text-sm text-brand-text italic mb-1.5 leading-snug" data-id="element-149">
                "{t.text}"
              </p>
              <p className="text-[11px] font-black text-brand-primary" data-id="element-150">
                – {t.name} ({t.location})
              </p>
            </div>)}
        </div>

        {/* Hero Quote — compact */}
        <div className="bg-white border-l-4 border-brand-secondary p-4 rounded-r-lg shadow-md max-w-2xl mx-auto text-left relative" data-id="element-151">
          <div className="flex text-brand-secondary mb-1.5" data-id="element-152">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-153" />)}
          </div>
          <p className="text-sm md:text-base font-medium text-brand-text italic mb-1.5" data-id="element-154">
            "Pasé de hacer cableados básicos a programar mi primer PLC en
            semanas. La mejor inversión de mi carrera."
          </p>
          <p className="text-xs font-bold text-brand-primary" data-id="element-155">
            – Ricardo M. (Colombia)
          </p>
        </div>
      </div>
    </section>;
}